import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { FC, ReactNode } from "react";
import {
  COLOR_BLACK,
  COLOR_ERROR,
  COLOR_GREY200,
  COLOR_GREY_12,
} from "shared/theme/colors";
import { CloseIcon } from "shared/theme/icons/CloseIcon";
import {
  StyledBox,
  StyledButtonsPopup,
  StyledCancelButton,
  StyledDeleteButton,
  StyledModal,
  StyledTitle,
} from "./styled";

type DeleteConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  handleSuccess?: () => void;
  title: string;
  content?: string | ReactNode;
  applyButtonTitle?: string;
  cancelButtonTitle?: string;
  applyButtonLoading?: boolean;
  hideActionBar?: boolean;
  primaryButtonColor?: string;
  children?: React.ReactNode;
};

const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  open,
  onClose,
  handleSuccess,
  title,
  content,
  applyButtonTitle,
  cancelButtonTitle = "Cancel",
  applyButtonLoading = false,
  hideActionBar = false,
  primaryButtonColor = COLOR_ERROR,
  children,
}) => (
  <StyledModal open={open} onClose={onClose}>
    <StyledBox>
      <Stack flexDirection="row">
        <Box />
        <StyledTitle variant="heading3" color={COLOR_BLACK}>
          {title}
        </StyledTitle>
        {hideActionBar ? (
          <IconButton onClick={onClose}>
            <CloseIcon color={COLOR_GREY200} />
          </IconButton>
        ) : (
          <Box />
        )}
      </Stack>
      {content && (
        <Typography variant="bodyLRegular" color={COLOR_GREY_12}>
          {content}
        </Typography>
      )}
      {children}
      {!hideActionBar && (
        <StyledButtonsPopup>
          <StyledCancelButton
            title={cancelButtonTitle}
            onClick={onClose}
            size="small"
            variant="outlined"
          />
          {applyButtonTitle && (
            <StyledDeleteButton
              title={applyButtonTitle}
              onClick={handleSuccess}
              size="small"
              loading={applyButtonLoading}
              buttonColor={primaryButtonColor}
            />
          )}
        </StyledButtonsPopup>
      )}
    </StyledBox>
  </StyledModal>
);

export default DeleteConfirmationModal;
